import type { ImageId } from '../../assets/marketing/manifest';

export interface Pillar {
  id: string;
  label: string;
  /** [main frame, aside frame]. The aside is hidden below 768px. */
  images: [ImageId, ImageId];
}

/**
 * "YOUR HEALTH, MANAGED." — the eight things Melio brings together, in the
 * mockup's order (guidelines p.54). The list is the content; the images swap
 * with the active item.
 */
export const PILLARS: Pillar[] = [
  { id: 'sleep', label: 'Sleep', images: ['pillar-sleep', 'pillar-sleep-b'] },
  { id: 'movement', label: 'Movement', images: ['pillar-movement', 'pillar-movement-b'] },
  { id: 'nutrition', label: 'Nutrition', images: ['pillar-nutrition', 'pillar-nutrition-b'] },
  { id: 'family-history', label: 'Family history', images: ['pillar-family', 'pillar-family-b'] },
  { id: 'bloodwork', label: 'Bloodwork', images: ['pillar-bloodwork', 'pillar-bloodwork-b'] },
  { id: 'medical-records', label: 'Medical records', images: ['pillar-records', 'pillar-records-b'] },
  { id: 'specialists', label: 'Specialists', images: ['pillar-specialists', 'pillar-specialists-b'] },
  { id: 'lifestyle', label: 'Lifestyle', images: ['pillar-lifestyle', 'pillar-lifestyle-b'] },
];
